export default {
  '***': {
    '***': {
      '***': [
        {
          "id": 10,
          "label": "Brand Image",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            20,
            25,
            30,
            40,
            50
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 20,
          "label": "Awards/Accolades",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Refers to any reference of awards or rankings, 3rd party or commissioned research based."
        },
        {
          "id": 25,
          "label": "Customer Service",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Refers to a primary focus on customer service"
        },
        {
          "id": 30,
          "label": "Co-Brand",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Single ad advertising for more than one brand ('Seamless + Taco Bell' or 'Marriott Chase credit card')"
        },
        {
          "id": 40,
          "label": "General Reputation",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Refers to any ad that focuses on a brand's general reputation, but does not mention any products"
        },
        {
          "id": 50,
          "label": "Sponsorship",
          "selected": 0,
          "collapse": 0,
          "parent": 10,
          "children": [],
          "tooltip": "Sponsorship of an event, sport or project (such as a food bank)"
        },

        {
          "id": 100,
          "label": "Creative Type",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            110,
            120,
            130,
            140
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 110,
          "label": "Narrative",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "Ad follows a story trajectory, even if short"
        },
        {
          "id": 120,
          "label": "Vignette/Montage",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "Ad does not have a story, but rather many different scenes cut together"
        },
        {
          "id": 130,
          "label": "Animated",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "At least half of ad is cartoon/animation and not filmed"
        },
        {
          "id": 140,
          "label": "Graphics/Animated Text Only",
          "selected": 0,
          "collapse": 0,
          "parent": 100,
          "children": [],
          "tooltip": "Ad is a computer generated ad usually focusing on a product with few or no actual filmed scenes/beauty shots"
        },
        {
          "id": 1,
          "label": "Creative Style",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            11,
            12,
            13
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 2,
          "label": "Humorous",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "The intent of the ad is to make you laugh"
        },
        {
          "id": 3,
          "label": "Emotional",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "The intent of the ad is to elicit sad or heartwarming emotion"
        },
        {
          "id": 4,
          "label": "Spokesperson",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "Includes both celebrity and non-celebrity spokespeople"
        },
        {
          "id": 12,
          "label": "Patient Depictions",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "Includes portrayals of patients in the ad"
        },
        {
          "id": 5,
          "label": "Celebrity (for brand NOT content)",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "Includes any celebrity inclusion, whether or not that person is a spokesperson"
        },
        {
          "id": 6,
          "label": "Music (jingle)",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "Refers to a consistent jingle associated with a brand, not just background music"
        },
        {
          "id": 7,
          "label": "Music (lyrics/song)",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "Refers to an identifiable song - either lyrics or instrumental"
        },
        {
          "id": 13,
          "label": "No Music",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "Refers to ads with no sound"
        },
        {
          "id": 8,
          "label": "Branding in Intro (First 5 seconds)",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "The advertising brand is shown or spoken in the first 5 seconds"
        },
        {
          "id": 9,
          "label": "Voice Over Narration",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "An off-screen narrator is featured"
        },
        {
          "id": 11,
          "label": "Continuity",
          "selected": 0,
          "collapse": 0,
          "parent": 1,
          "children": [],
          "tooltip": "Ad uses an existing creative construct and/or established brand cues"
        },
        {
          "id": 200,
          "label": "Ad Manufacturer",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            210,
            220,
            230,
            240,
            250
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 210,
          "label": "Abbvie",
          "selected": 0,
          "collapse": 0,
          "parent": 200,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 220,
          "label": "Incyte Dermatology",
          "selected": 0,
          "collapse": 0,
          "parent": 200,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 230,
          "label": "Leo Pharma",
          "selected": 0,
          "collapse": 0,
          "parent": 200,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 240,
          "label": "Pfizer",
          "selected": 0,
          "collapse": 0,
          "parent": 200,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 250,
          "label": "Sanofi Genzyme",
          "selected": 0,
          "collapse": 0,
          "parent": 200,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 300,
          "label": "Offers",
          "selected": 0,
          "collapse": 0,
          "parent": 0,
          "children": [
            310,
            320,
            330
          ],
          "tooltip": "This will be checked automatically when any item in this section is checked."
        },
        {
          "id": 310,
          "label": "Copay assistance",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 320,
          "label": "Now Approved",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": ""
        },
        {
          "id": 330,
          "label": "Savings",
          "selected": 0,
          "collapse": 0,
          "parent": 300,
          "children": [],
          "tooltip": ""
        }
      ]
    }
  }
};


// WEBPACK FOOTER //
// ./src/app/configuration/Pfizer/config/components/selection/Search/tagHierarchy.js